const reviewsForm = () => {
	
	$(document).ready(function () {
		let starsID = '#stars li';
		
		$(starsID).on('mouseover', function () {
			let onStar = parseInt($(this).data('value'), 10);
			
			$(this).parent().children('li.star').each(function (e) {
				if (e < onStar) {
					$(this).addClass('hover');
				}
				else {
					$(this).removeClass('hover');
				}
			});
			
		}).on('mouseout', function () {
			$(this).parent().children('li.star').each(function (e) {
				$(this).removeClass('hover');
			});
		});
		
		$(starsID).on('click', function () {
			let onStar = parseInt($(this).data('value'), 10); // The star currently selected
			let stars = $(this).parent().children('li.star');
			
			for (let i = 0; i < stars.length; i++) {
				$(stars[i]).removeClass('selected');
			}
			
			for (let i = 0; i < onStar; i++) {
				$(stars[i]).addClass('selected');
			}
			
			//JUST RESPONSE (Not needed)
			let ratingValue = parseInt($('#stars').find('li.selected').last().data('value'), 10);
			// let msg = "";
			// if (ratingValue > 1) {
			// 	msg = "Thanks! You rated this " + ratingValue + " stars.";
			//
			// }
			// else {
			// 	msg = "We will improve ourselves. You rated this " + ratingValue + " stars.";
			// }
			// responseMessage(msg);
			responseMessage(ratingValue);
		});
		
		
	});
	
	function responseMessage(ratingValue) {
		// $('.success-box').fadeIn(200);
		// $('.success-box div.text-message').html("<span>" + msg + "</span>");
		$("input#starsRate").val(ratingValue);
	}
	
};

export {reviewsForm};


// WEBPACK FOOTER //
// ../components/products/details/reviewsForm/reviewsForm.js